import { useEffect } from 'react';
import { Routes, useLocation, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import {
  BulkEmails,
  Deposit,
  Deposits,
  Home,
  Profits,
  Messages,
  Overview,
  Settings,
  UserPage,
  Users,
  Wallets,
  Bonus,
  BankWithdrawals,
  BankWithdrawal,
  CryptoWithdrawals,
  CryptoWithdrawal,
  TradingPlans,
  TradingPlan,
  KYCs,
  UserKYC,
} from './pages';

import { PrivateRoute } from './pages/PrivateRoute';

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, [pathname]);

  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />

        {/* dashboard pages */}
        <Route element={<PrivateRoute />}>
          <Route path='/dashboard/overview' element={<Overview />} />
          <Route path='/dashboard/settings' element={<Settings />} />
          <Route path='/dashboard/wallets' element={<Wallets />} />
          <Route path='/dashboard/messages' element={<Messages />} />
          <Route path='/dashboard/users' element={<Users />} />
          <Route path='/dashboard/users/:id' element={<UserPage />} />
          <Route path='/dashboard/deposits' element={<Deposits />} />
          <Route path='/dashboard/deposits/:id' element={<Deposit />} />
          <Route
            path='/dashboard/bank-withdrawals'
            element={<BankWithdrawals />}
          />
          <Route
            path='/dashboard/bank-withdrawals/:id'
            element={<BankWithdrawal />}
          />
          <Route
            path='/dashboard/crypto-withdrawals'
            element={<CryptoWithdrawals />}
          />
          <Route
            path='/dashboard/crypto-withdrawals/:id'
            element={<CryptoWithdrawal />}
          />
          <Route path='/dashboard/trading-plans' element={<TradingPlans />} />
          <Route
            path='/dashboard/trading-plans/:id'
            element={<TradingPlan />}
          />
          <Route path='/dashboard/kyc' element={<KYCs />} />
          <Route path='/dashboard/kyc/:id' element={<UserKYC />} />
          <Route path='/dashboard/profits' element={<Profits />} />
          <Route path='/dashboard/bonus' element={<Bonus />} />
          <Route path='/dashboard/bulk-emails' element={<BulkEmails />} />
        </Route>
      </Routes>

      <Toaster position='top-center' />
    </>
  );
}

export default App;
